import { render } from "./TaskBody.vue?vue&type=template&id=b028cbc6&scoped=true"
import script from "./TaskBody.vue?vue&type=script&lang=js"
export * from "./TaskBody.vue?vue&type=script&lang=js"

import "./TaskBody.vue?vue&type=style&index=0&id=b028cbc6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b028cbc6"]])

export default __exports__